import { useMemo, useState } from "react";

import Grid from "@mui/material/Grid";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { LoadingOrValue, MeatballMenu } from "@covertree/ui";
import { determineIfNoEmailAddress, formatPhoneNumber } from "@covertree/utils";
import { useAccessPattern } from "@hooks/useAccessPattern";

import { PolicyDetailsContentProps } from "../../../types";
import { EditContactForm } from "./UpdateContactInfoModal/form";
import { UpdateContactInfoModal } from "./UpdateContactInfoModal";

export function ContactInfo({ policy, loading }: PolicyDetailsContentProps) {
  const { canEditPolicyholder } = useAccessPattern();
  const [open, setOpen] = useState<boolean>(false);
  const {
    primaryContactNumber,
    secondaryContactNumber,
    emailAddress,
    policyholderLocator,
  } = policy.policyholder;

  const defaultValues: EditContactForm = useMemo(
    () => ({
      emailAddress,
      primaryContactNumber,
      secondaryContactNumber,
      noEmail: determineIfNoEmailAddress(emailAddress, primaryContactNumber),
    }),
    [emailAddress, primaryContactNumber, secondaryContactNumber]
  );

  return (
    <>
      <Grid item xs={12}>
        <DisplayPropertiesCard
          properties={[
            {
              label: "Phone number",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={
                    primaryContactNumber
                      ? formatPhoneNumber(primaryContactNumber)
                      : "None"
                  }
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
            {
              label: "Secondary phone number",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={
                    secondaryContactNumber
                      ? formatPhoneNumber(secondaryContactNumber)
                      : "None"
                  }
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
            {
              label: "Email",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={
                    determineIfNoEmailAddress(
                      emailAddress,
                      primaryContactNumber
                    )
                      ? "None"
                      : emailAddress
                  }
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 12,
            },
          ]}>
          {canEditPolicyholder && (
            <MeatballMenu
              actionMenuItems={[
                { label: "Edit", onClick: () => setOpen(true) },
              ]}
              border
              closeOnClick
            />
          )}
        </DisplayPropertiesCard>
      </Grid>

      {/* Note: conditional render allows to get updated defaultValues  */}
      {open && (
        <UpdateContactInfoModal
          open={open}
          onClose={() => setOpen(false)}
          defaultValues={defaultValues}
          policyholderLocator={policyholderLocator}
        />
      )}
    </>
  );
}
